<div class="drivers-modal">
  <div class="drivers-modal-header">
    <h3 class="drivers-title">
      {{ 'modals.add_assignament.drivers_modal.title' | translate }}
    </h3>
  </div>

  <div class="drivers-modal-filters">
    <tui-input
      class="driver-search"
      tuiTextfieldIconLeft="tuiIconSearch"
      [formControl]="searchControl"
      [tuiTextfieldLabelOutside]="true"
    >
      {{ 'modals.add_assignament.drivers_modal.search_placeholder' | translate }}
    </tui-input>

    <ng-select
      class="driver-select"
      [items]="operatorTypeOptions"
      bindLabel="labelKey"
      bindValue="value"
      [clearable]="true"
      [searchable]="false"
      [formControl]="operatorTypeControl"
      [placeholder]="'service_manager.gantt.operator_type_label' | translate"
    >
      <ng-template ng-label-tmp let-item="item">{{ item.labelKey | translate }}</ng-template>
      <ng-template ng-option-tmp let-item="item">{{ item.labelKey | translate }}</ng-template>
    </ng-select>

    <ng-select
      *ngIf="showDriverTypeFilter"
      class="driver-select"
      [items]="driverTypeOptions"
      bindLabel="labelKey"
      bindValue="value"
      [clearable]="true"
      [searchable]="false"
      [formControl]="driverTypeControl"
      [placeholder]="'service_manager.gantt.driver_type_label' | translate"
    >
      <ng-template ng-label-tmp let-item="item">{{ item.labelKey | translate }}</ng-template>
      <ng-template ng-option-tmp let-item="item">{{ item.labelKey | translate }}</ng-template>
    </ng-select>

    <div class="select-all-wrapper">
      <tui-toggle
        class="select-all-toggle"
        size="l"
        [ngModel]="allVisibleSelected"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onToggleSelectAll($event)"
      ></tui-toggle>
      <span class="select-all-label">
        {{ 'modals.add_assignament.drivers_modal.select_all' | translate }}
      </span>
    </div>
  </div>

  <div class="drivers-counts-section">
    <p class="drivers-included-count">
      {{ 'modals.add_assignament.drivers_modal.included' | translate : { included: includedDrivers } }}
    </p>
    <p class="showing-counter" *ngIf="(filteredDrivers$ | async) as drivers">
      {{
        'modals.add_assignament.drivers_modal.showing_results'
          | translate : { showing: filteredCount, total: totalDrivers }
      }}
    </p>
  </div>

  <div class="drivers-list" *ngIf="filteredDrivers$ | async as drivers">
    <div class="driver-card" *ngFor="let driver of drivers; trackBy: trackByDriverId">
      <div class="driver-card-layout">
        <div class="driver-column-left">
          <div class="driver-card-header">
            <label class="driver-checkbox">
              <input
                type="checkbox"
                [checked]="isDriverSelected(driver.driverId)"
                (change)="toggleDriverSelection(driver.driverId, $any($event.target).checked)"
              />
              <span class="checkbox-mark"></span>
            </label>

            <div class="driver-meta">
              <p class="driver-name">{{ driver.fullName }}</p>
              <p class="driver-type" *ngIf="driver.driverType as type">
                {{ getDriverTypeTranslationKey(type) | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="driver-column-right">
          <div class="schedule-selector">
            <button
              type="button"
              class="schedule-option"
              [class.active]="driver.schedule.mode === 'full'"
              (click)="changeScheduleMode(driver.driverId, 'full')"
            >
              {{ 'modals.add_assignament.drivers_modal.full_schedule' | translate }}
            </button>
            <button
              type="button"
              class="schedule-option"
              [class.active]="driver.schedule.mode === 'split'"
              (click)="changeScheduleMode(driver.driverId, 'split')"
            >
              {{ 'modals.add_assignament.drivers_modal.split_schedule' | translate }}
            </button>
          </div>

          <div class="schedule-grid" *ngIf="driver.schedule.mode === 'full'; else splitSchedule">
            <div class="schedule-col">
              <label>{{ 'modals.add_assignament.drivers_modal.entry' | translate }}</label>
              <input
                type="text"
                placeholder="HH:mm"
                maxlength="5"
                [(ngModel)]="driver.schedule.full.start"
                [ngModelOptions]="{ standalone: true }"
                (input)="onTimeInput($event, driver, 'fullStart')"
              />
            </div>
            <div class="schedule-col">
              <label>{{ 'modals.add_assignament.drivers_modal.exit' | translate }}</label>
              <input
                type="text"
                placeholder="HH:mm"
                maxlength="5"
                [(ngModel)]="driver.schedule.full.end"
                [ngModelOptions]="{ standalone: true }"
                (input)="onTimeInput($event, driver, 'fullEnd')"
              />
            </div>
          </div>
        </div>
      </div>

      <ng-template #splitSchedule>
        <div class="schedule-grid split">
          <div class="schedule-col">
            <label>{{ 'modals.add_assignament.drivers_modal.morning' | translate }}</label>
            <div class="split-time-range">
              <input
                type="text"
                placeholder="HH:mm"
                maxlength="5"
                [(ngModel)]="driver.schedule.split.morningStart"
                [ngModelOptions]="{ standalone: true }"
                (input)="onTimeInput($event, driver, 'morningStart')"
              />
              <span class="range-separator">-</span>
              <input
                type="text"
                placeholder="HH:mm"
                maxlength="5"
                [(ngModel)]="driver.schedule.split.morningEnd"
                [ngModelOptions]="{ standalone: true }"
                (input)="onTimeInput($event, driver, 'morningEnd')"
              />
            </div>
          </div>

          <div class="schedule-col">
            <label>{{ 'modals.add_assignament.drivers_modal.afternoon' | translate }}</label>
            <div class="split-time-range">
              <input
                type="text"
                placeholder="HH:mm"
                maxlength="5"
                [(ngModel)]="driver.schedule.split.afternoonStart"
                [ngModelOptions]="{ standalone: true }"
                (input)="onTimeInput($event, driver, 'afternoonStart')"
              />
              <span class="range-separator">-</span>
              <input
                type="text"
                placeholder="HH:mm"
                maxlength="5"
                [(ngModel)]="driver.schedule.split.afternoonEnd"
                [ngModelOptions]="{ standalone: true }"
                (input)="onTimeInput($event, driver, 'afternoonEnd')"
              />
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="empty-state" *ngIf="!drivers.length">
      {{ 'modals.add_assignament.drivers_modal.no_drivers' | translate }}
    </div>
  </div>

  <div class="drivers-modal-footer">
    <button tuiButton type="button" size="s" appearance="secondary" class="cancel-btn" (click)="close()">
      {{ 'modals.add_assignament.drivers_modal.cancel' | translate }}
    </button>
    <button tuiButton type="button" size="s" appearance="primary-button" class="save-btn" (click)="save()">
      {{ 'modals.add_assignament.drivers_modal.save' | translate }}
    </button>
  </div>
</div>
